/*global google*/
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import config from '../../../js/config/mapconfig';

// const googleMapsKey = ''; // LOCAL TEST
const googleMapsKey = 'AIzaSyD-zJnv8GB5ZKc77zsOBgdMF8nRlqo6ru8';

function EstablishmentMap(props) {
  const { establishment, mapsLoaded, setMapsLoaded } = props;

  const mapElem = useRef(null);
  const mapContent = useRef(null);

  useEffect(() => {
    if (mapsLoaded && mapElem) {
      const vw = document.documentElement.clientWidth;
      let siteWidthOffset;
      if (vw < 1360) {
        siteWidthOffset = 24;
      } else {
        siteWidthOffset = (vw - 1360) / 2;
      }

      const location = {
        lat: parseFloat(establishment.location.lat),
        lng: parseFloat(establishment.location.lng),
      };

      const markerIcon = {
        url: '/_resources/themes/schellevis/img/marker/marker-car.svg',
        scaledSize: new google.maps.Size(36, 36), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(18, 18), // anchor
      };

      const map = new google.maps.Map(
        mapElem.current,
        config('default', 12, location),
      );

      // eslint-disable-next-line no-new
      new google.maps.Marker({
        map,
        position: location,
        icon: markerIcon,
      });

      if (mapContent) {
        map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(mapContent.current);
        mapContent.current.style.marginLeft = `${siteWidthOffset}px`;
      }
    }
  }, [mapsLoaded, establishment]);

  if (!mapsLoaded) {
    // Create the script tag, set the appropriate attributes
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}`;
    script.defer = true;

    script.onload = () => {
      setMapsLoaded(true);
    };

    // Append the 'script' element to 'head'
    document.head.appendChild(script);
  }

  return (
    <section ref={mapElem} className="map ratio--3x1 ratio--4x3--palm">
      <div className="sign--palm" />
      <div className="site-width sign--palm">
        <div ref={mapContent} className="map-island">
          <address className="sign">
            <div className="heading-s sign-s">{establishment.title}</div>
            {`${establishment.address.street} ${establishment.address.houseNumber}`}
            <br />
            {`${establishment.address.postalCode} ${establishment.address.city}`}
          </address>
          <a href={`https://www.google.nl/maps/dir/${establishment.address.street}%20${establishment.address.houseNumber},${establishment.address.postalCode}%20${establishment.address.city}/@${establishment.location.lat},${establishment.location.lng}/`} target="_blank" rel="nofollow noreferrer" className="button-arrow button-arrow--s">
            <span className="hidden--palm">{ss.i18n._t('EstablishmentApp.MAP_ROUTE_LABEL')}</span>
            <span className="hidden--gt-palm">{ss.i18n._t('EstablishmentApp.MAP_ROUTE_PALM_LABEL')}</span>
          </a>
        </div>
      </div>
    </section>
  );
}

EstablishmentMap.propTypes = {
  establishment: PropTypes.shape({
    id: PropTypes.number,
    image: PropTypes.object,
    title: PropTypes.string,
    address: PropTypes.object,
    location: PropTypes.object,
  }).isRequired,
  mapsLoaded: PropTypes.bool.isRequired,
  setMapsLoaded: PropTypes.func.isRequired,
};

export default EstablishmentMap;
